module.exports = __webpack_public_path__ + "static/media/Gilroy-Regular.6728ae88.eot";